import { Box, FormControl, MenuItem, Select, Typography } from "@common-ui/ui";
import { DetailPanels } from "../../components";
import { TimeController } from "./TimeController";
import { useSelector } from "react-redux";
import { StatusChip } from "./StatusChip";
import { orderBy } from "lodash";
import { GenerateReportBox } from "./GenerateReportBox";
import { SummaryResult } from "./SummaryResult";
import checkTableImage from "../../utils/checkTableImage";

export const WorkItemTableView = (props) => {
  // console.log("WorkItemTableView props", props);

  const workItems = useSelector((state) => state.workItems);

  const getItemStatus = (itemId) => {
    return workItems[itemId].status;
  };

  const columns = [
    {
      field: "id",
      flex: 1,
      headerName: (
        <Typography fontWeight="700" variant="body2">
          Work Item
        </Typography>
      ),
      renderCell: (params) => {
        return params?.row?.id; // <WorkItemLink params={params} />;
      },
    },
    {
      width: 100,
      field: "image_url",
      headerName: "",
      align: "center",
      sortable: false,
      renderCell: (params) => checkTableImage(params?.row?.asset?.image_url),
    },
    {
      field: "asset_name",
      flex: 1,
      headerName: (
        <Typography fontWeight="700" variant="body2">
          Asset Name
        </Typography>
      ),
      renderCell: (params) => {
        return params?.row?.asset?.name ? params?.row?.asset?.name : "---";
      },
    },
    {
      field: "asset",
      flex: 1,
      headerName: (
        <Typography fontWeight="700" variant="body2">
          Asset ID
        </Typography>
      ),
      renderCell: (params) => {
        return params?.row?.asset?.id ? params?.row?.asset?.id : "---";
      },
    },
    {
      field: "make",
      flex: 1,
      headerName: (
        <Typography fontWeight="700" variant="body2">
          Make
        </Typography>
      ),
      renderCell: (params) => {
        return params?.row?.asset?.make ? params?.row?.asset?.make : "---";
      },
    },
    {
      field: "model",
      flex: 1,
      headerName: (
        <Typography fontWeight="700" variant="body2">
          Model
        </Typography>
      ),
      renderCell: (params) => {
        return params?.row?.asset?.model ? params?.row?.asset?.model : "---";
      },
    },
    {
      field: "report",
      flex: 1,
      headerName: (
        <Typography fontWeight="700" variant="body2">
          Report
        </Typography>
      ),
      renderCell: (params) => {
        // console.log(params);
        let status =
          params.row.procedure?.status?.procedure?.num_completed !== 0 &&
          params.row.procedure?.status?.procedure?.num_steps ===
            params.row.procedure?.status?.procedure?.num_completed
            ? "COMPLETED"
            : params.row.procedure?.status?.procedure?.num_completed !== 0
            ? "STARTED"
            : "NOT STARTED";
        if (!params.row.procedure?.status?.procedure?.num_completed) {
          status = "NOT STARTED";
        }

        return <GenerateReportBox status={status} params={params} />;
      },
    },
    {
      field: "status",
      flex: 1,
      // width: 200,
      headerName: <Typography fontWeight="700">Status</Typography>,
      renderCell: (params) => {
        let status;
        let itemId = params.row.id;

        status = params.value ? getItemStatus(itemId) : "";

        return params.value === "NOT_STARTED" ||
          params.value === "DRAFT" ||
          params.value === "COMPLETED" ||
          params.value === "CANCELLED" ? (
          <StatusChip status={status} />
        ) : (
          <FormControl variant="standard" size="small">
            <Select
              disableUnderline={true}
              labelId="demo-select-small"
              id="demo-select-small"
              value={params.value}
              onChange={(event) =>
                props.workItemStatusChange(
                  event,
                  params.row.work_event,
                  params.row.id
                )
              }
              renderValue={() => <StatusChip status={status} />}
            >
              <MenuItem value={"IN_PROGRESS"}>In Progress</MenuItem>
              <MenuItem value={"ON_HOLD"}>On Hold</MenuItem>
              <MenuItem value={"PENDING"}>Pending</MenuItem>
              <MenuItem value={"IN_REVIEW"}>In Review</MenuItem>
              {props.appRole === "ADMIN" || props.appRole === "SUPERVISOR" ? (
                <MenuItem
                  value={"COMPLETED"}
                  disabled={
                    params.row.procedure?.status?.procedure?.num_completed === 0
                  }
                >
                  Completed
                </MenuItem>
              ) : (
                ""
              )}
            </Select>
          </FormControl>
        );
      },
    },
    {
      field: "procedure_result_code",
      flex: 1,
      headerName: (
        <Typography fontWeight="700" variant="body2">
          Summary Result
        </Typography>
      ),
      renderCell: (params) => {
        const { id, work_event, performing_org } = params?.row;
        let row = params.row;
        let itemId = params.row.id;
        let status = getItemStatus(itemId);
        let started =
          params.row.procedure?.status?.procedure?.num_completed !== 0;

        let completed = status === "COMPLETED" || status === "CANCELLED";
        let isDraft = status === "DRAFT";
        return (
          <>
            <SummaryResult
              id={id}
              work_event={work_event}
              performing_org={performing_org}
              value={params?.value}
              params={params}
            />
            <div>
              <TimeController
                row={row}
                isDraft={isDraft}
                completed={completed}
                started={started}
                params={params}
              />
            </div>
          </>
        );
      },
    },
  ];
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          height: "100%",
          // height: 400,
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
        }}
      >
        <DetailPanels
          {...props}
          data={orderBy(props?.data, ["id"], ["asc"])}
          columns={columns}
        />
      </Box>
    </>
  );
};
